import React from 'react';
import { useSelector } from 'react-redux';
import { Field, TextOutput, Message } from '../../Core';
import { FieldSet, ListFieldSection } from '../../Layout';
import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListDropdown } from 'Components/List';
import { pipe } from 'Lib/Hooks/Selectors';
import { hasValue } from 'Lib/Any';
import * as oPath from '../../../Lib/Object/Path/Immutable';

let DriverInterfacingSection: React.FC = () => {
  //Used to filter the drivers by Equipment Type
  const EquipmentTypeId = useSelector((state: any) => state.equipment.equipmentType.Id);
  const isDriverSelected = useSelector(
    pipe((state: any) => oPath.get(state.equipment.syncModel, 'data.Driver'), hasValue)
  );
  return (
    <ListFieldSection>
      <NamePrefixModifier appendNamePrefix="Driver">
        <FieldSet horizontalLabelWidth="medium">
          <Field
            input={<ListDropdown />}
            endpoint="list.equipment.drivers"
            name="Id"
            queryParams={{ EquipmentTypeId }}
            simpleValue
            searchImmediately
            maxResults={20}
            label="Driver"
          />
          {isDriverSelected && (
            <>
              <Message border={false}>This driver has been configured for use with the following equipment:</Message>

              <NamePrefixModifier appendNamePrefix="Data">
                <Field input={<TextOutput />} label="Make" name="EquipmentMake" horizontal />
                <Field input={<TextOutput />} label="Model" name="EquipmentModelNo" horizontal />
                <Field
                  input={<TextOutput />}
                  label="Year of Manufacture"
                  name="EquipmentYearOfManufacture"
                  horizontal
                />
              </NamePrefixModifier>
            </>
          )}
        </FieldSet>
      </NamePrefixModifier>
    </ListFieldSection>
  );
};

DriverInterfacingSection = withInjectedProps(DriverInterfacingSection);

export default DriverInterfacingSection;
export { DriverInterfacingSection };
